import { Row, Col } from "antd";
import AnimateItems from "../../../utils/AnimateItems";
import GeneralSection from "./sections/GeneralSection";
import PVSection from "./sections/PVSection";
import PFSection from "./sections/PFSection";
import PSSection from "./sections/PSSection";
import PASection from "./sections/PASection";
import InstalacionSection from "./sections/InstalacionSection";
import ArancelesSection from "./sections/ArancelesSection";
import Nom007Section from "./sections/Nom007Section";
import Nom013Section from "./sections/Nom013Section";
import Subtitle from "../Subtitle";
import NotasSection from "./sections/NotasSection";
import GeneralFor7And13 from "./sections/GeneralFor7And13";

export default function SectionViews(props) {
  const { verification } = props;

  const showNom001 = verification?.Nom001 === "Sí";
  const showNom007 = verification?.Nom007 === "Sí";
  const showNom013 = verification?.Nom013 === "Sí";

  return (
    <div>
      <AnimateItems delay={0.15}>
        {showNom001 && (
          <>
            <Subtitle title="Datos generales" marginTop={0} />
            <GeneralSection {...props} />
            <PVSection {...props} />
            <Subtitle title="Personas involucradas" marginTop={16} />
            <Row gutter={[16, 16]}>
              <PFSection {...props} />
              <PASection {...props} />
              <PSSection {...props} />
            </Row>
            <InstalacionSection {...props} />
            <ArancelesSection {...props} />
            <NotasSection {...props} />
          </>
        )}

        {(showNom007 || showNom013) && (
          <>
            <Subtitle title="Datos generales" marginTop={0} />
            <Row gutter={[16, 16]}>
              <GeneralFor7And13 {...props} />
            </Row>
            <PVSection {...props} />
          </>
        )}

        {showNom007 && (
          <>
            <Nom007Section {...props} />
            <ArancelesSection {...props} />
            <NotasSection {...props} />
          </>
        )}

        {showNom013 && (
          <>
            <Nom013Section {...props} />
            <ArancelesSection {...props} />
            <NotasSection {...props} />
          </>
        )}
      </AnimateItems>
    </div>
  );
}